// extracted by mini-css-extract-plugin
module.exports = {"borderTag":"style_borderTag__s2UJ6"};